/*
 * @Description: 自动生成代码无需修改，可跑npm run services来重新生成
 */
import http from '@lib/http';
import { GetServerSidePropsContext } from 'next';

export interface Body {
  /**
   * 活动ID
   */
  event_id: string;
  /**
   * 日程ID
   */
  scheduler_id?: string;
}
/**
 * 权限点列表（live_audience、join_meeting等)
 */
export type AuthList = string[];
export interface LobbyUserGetUserAuthorityRes {
  code?: number;
  data: Data;
  msg?: string;
  nonce?: string;
}
export interface Data {
  /**
   * 用户角色（按位与，0表示是路人，1表示是主持人，2表示是嘉宾，4表示是观众）
   */
  user_role_id: number;
  /**
   * 组织成员角色权限，0无角色，1 创建者，2 管理员
   */
  org_role_id: number;
  auth_list: AuthList;
  /**
   * 用户使用完成实名认证
   */
  is_identity: boolean;
  /**
   * 环境env，比如ci-5、prerelease、formal
   */
  env_name: string;
  /**
   * 环境namespace，比如Test、Pre-release、Production
   */
  namespace: string;
}

const LobbyUserGetUserAuthority = async (data: Body, ctx?: GetServerSidePropsContext) => {
  const res = await http.post<LobbyUserGetUserAuthorityRes>(
    '/wemeet-tapi',
    '/v2/activities/lobby/user/get-user-authority',
    data,
    ctx,
  );

  return res;
};

export default LobbyUserGetUserAuthority;
